import { Button, Header, Segment } from "semantic-ui-react";

import React from "react";

import Flex from "../../../../../components/Flex/Flex";
import TeamPrice from "../../../../team/components/TeamPrice/TeamPrice";
import ImageAvatar from "../../../../ui/components/ImageAvatar/ImageAvatar";

export default function CreateProductionReaderListItem({ reader, onClick }) {
	return (
		<Segment style={{ width: 500, margin: "auto" }}>
			<Flex alignItems="center" justifyContent="flex-start">
				<ImageAvatar src={reader.avatarImg} style={{ width: 40, height: 40, marginRight: "1em" }} />

				<div>
					<Header as="h5" style={{ margin: 0 }}>
						{reader.name}
					</Header>

					<div style={{ opacity: 0.4, fontSize: "0.9em" }}>
						<TeamPrice role={reader.role} price={reader.price} showCa={reader.price.price} />
					</div>
				</div>
			</Flex>

			<Button
				basic
				circular
				icon="minus"
				style={{
					height: 28,
					width: 28,
					padding: 0,
					position: "absolute",
					right: 15,
					top: 20,
				}}
				onClick={onClick}
			/>
		</Segment>
	);
}
